// extracted by mini-css-extract-plugin
export var box = "_7u-1";
export var checkboxRow = "_7u-8";
export var checked = "_7u-2";
export var descriptionSpacer = "_7u-a";
export var disabled = "_7u-3";
export var icon = "_7u-6";
export var input = "_7u-0";
export var labelSpacer = "_7u-9";
export var medium = "_7u-5";
export var small = "_7u-4";
export var text = "_7u-7";